import { createFromIconfontCN } from '@ant-design/icons';

const IconFont = createFromIconfontCN({
	scriptUrl: require('./icon-font'),
    // scriptUrl的值是从阿里图标库中复制过来的，每次添加了图标都要重新复制新的链接
    // 为了动态设置svg颜色，移除了icon-font.js中的fill="#1453E1"属性
});

export default IconFont;